<template>
  <div style="width:100%;height:100%">
    <div style="display:flex;justify-content:space-between;padding:12px;height:60px;">
      <div>
        <a-button :disabled="!selectVersion || v.versionStatus == 1" style="margin-right:10px" @click="fixVersion">{{$t("page_bom_fix")}}</a-button>
        <a-popconfirm
          :title="$t('delete_tips')"
          @confirm="deleteVersion"
          :okText="$t('ok')"
          :cancelText="$t('cancel')"
          :disabled="!selectVersion || v.versionStatus == 1"
        >
          <a-button :disabled="!selectVersion || v.versionStatus == 1" type="danger">{{$t("page_bom_delete")}}</a-button>
        </a-popconfirm>
      </div>
      <div>
        <a-select style="margin-right:10px;width:100px;" 
        show-search
        :filter-option="filterOption"
        v-model="selectVersion">
          <a-select-option v-for="v in versions" :key="v.id" :value="v.id">
            {{v.version}}
          </a-select-option>
        </a-select>
        <a-button style="margin-right:10px" @click="craftVisible = true; selectCraft = null">{{$t("page_bom_create_version")}}</a-button>
        <a-button style="margin-right:10px" @click="remarkVisible = true; remark = v && v.remark || ''" :disabled="!selectVersion">{{$t("page_bom_version_remark")}}</a-button>
        <!-- <a-button style="margin-right:10px">复制</a-button>
        <a-button>导出</a-button> -->
      </div>
    </div>
    <div style="height:calc(100% - 60px);display:flex;">
      <div style="width:200px;height:100%;">
        <div style="overflow-y:auto;height:calc(100% - 40px)">
          <a-tree
            :defaultExpandAll="true"
            :tree-data="tree"
            @select="selectTree"
            :selectedKeys.sync="selects"
          />
        </div>
        <div style="text-align:center">
          <a-button v-if="v.versionStatus != 1" :disabled="!selectTreeId" @click="relateMaterial">{{$t("page_bom_relate")}}</a-button>
        </div>
      </div>
      <div style="width:calc(100% - 200px);padding:8px 24px;overflow-y:auto;">
        <div v-if="this.form">
          <div style="overflow-x:auto;width:100%;">
            <table class="bom-table">
              <tr>
                <th>{{$t("page_bom_no")}}</th>
                <th>{{$t("page_bom_name")}}</th>
                <th>{{$t("page_bom_ek")}}</th>
                <th>{{$t("page_bom_ak")}}</th>
                <th>{{$t("page_bom_level")}}</th>
                <th>{{$t("page_bom_plevel")}}</th>
                <th>{{$t("page_bom_xh")}}</th>
                <th>{{$t("page_bom_type")}}</th>
                <th>{{$t("page_bom_count")}}</th>
                <th>{{$t("page_bom_caizhi")}}</th>
                <th>{{$t("page_bom_beizhu")}}</th>
              </tr>
              <tr>
                <td>
                  <a-select :disabled="v.versionStatus == 1" style="width:200px" v-model="form.materialCode" 
                  show-search
                  :filter-option="filterOption"
                  @change="changeMaterial">
                    <a-select-option v-for="item in materials" :key="item.id" :value="item.code" :title="item.displayCode">
                      {{item.displayCode}}
                    </a-select-option>
                  </a-select>
                </td>
                <td>{{form.materialName}}</td>
                <td>{{form.lowerLimit}}</td>
                <td>{{form.upperLimit}}</td>
                <td>{{form.level}}</td>
                <td>{{form.parentLevel}}</td>
                <td>{{form.standardModel}}</td>
                <td>{{form.materialType}}</td>
                <td>{{form.unit}}</td>
                <td>{{form.stuff}}</td>
                <td>
                  <a-input :maxLength="200" v-if="v.versionStatus != 1" style="width:200px" v-model="form.remark"></a-input>
                  <ellipsis :length="10" tooltip v-else>
                    {{form.remark}}
                  </ellipsis>
                </td>
              </tr>
            </table>
          </div>
          <div style="overflow-x:auto;margin-top:24px;width:100%;" v-show="form.processAddDTOS.length">
            <table class="bom-table" style="width:100%">
              <tr>
                <th>{{$t("page_bom_action")}}</th>
                <th>{{$t("page_bom_gx")}}</th>
                <th>{{$t("page_bom_fenzi")}}</th>
                <th>{{$t("page_bom_fenmu")}}</th>
                <th>{{$t("page_bom_sunhao")}}%</th>
              </tr>
              <tr v-for="(item,index) in form.processAddDTOS" :key="index">
                <td style="width:10%">
                  <a-popconfirm
                    :title="$t('delete_tips')"
                    :okText="$t('ok')"
                    :cancelText="$t('cancel')"
                    @confirm="form.processAddDTOS.splice(index,1)"
                    :disabled="v.versionStatus == 1"
                  >
                    <a-button :disabled="v.versionStatus == 1" type="link">{{$t("page_bom_delete")}}</a-button>
                  </a-popconfirm>
                </td>
                <td style="width:22.5%">
                  <a-select :disabled="v.versionStatus == 1" style="width: 200px;" show-search
                  :filter-option="filterOption" v-model="item.processId" @change="(id) => changeProcess(id, item)">
                    <a-select-option v-for="p in processes" :key="p.id" :value="p.id">
                      {{ p.name }} ({{ p.processSequence }} - {{ p.code }})
                    </a-select-option>
                  </a-select>
                </td>
                <td style="width:25%"><a-input-number :min="1" :disabled="v.versionStatus == 1" v-model="item.molecule"></a-input-number></td>
                <td style="width:25%"><a-input-number :min="1" :disabled="v.versionStatus == 1" v-model="item.denominator"></a-input-number></td>
                <td style="width:25%"><a-input-number :min="1" :disabled="v.versionStatus == 1" v-model="item.loss"></a-input-number></td>
              </tr>
            </table>
          </div>
          <a-button v-if="v.versionStatus != 1" style="margin:32px 0;" type="primary" block @click="addProcess">{{$t("page_bom_add_gx")}}</a-button>
          <div>
            <a-button v-if="v.versionStatus != 1" style="margin:0 12px" type="primary" :loading="isLoading" @click="saveMaterial">{{$t("page_bom_save")}}</a-button>
            <a-popconfirm
              :title="$t('delete_tips')"
              :okText="$t('ok')"
              :cancelText="$t('cancel')"
              @confirm="cancelMaterial"
            >
              <a-button v-if="v.versionStatus != 1">{{$t("page_bom_delete")}}</a-button>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </div>
     <a-modal v-model="craftVisible" :title="$t('page_bom_realte_gybb')" @ok="createVersion">
       <div style="display:flex;justify-content:center;align-items:center">
         <span style="margin-right:12px">{{$t("page_bom_version")}}:</span>
         <a-select style="width:120px" 
         show-search
        :filter-option="filterOption"
         v-model="selectCraft">
          <a-select-option v-for="craft in crafts" :key="craft.id" :value="craft.id">
            {{craft.version}}
          </a-select-option>
        </a-select>
       </div>
    </a-modal>
    <a-modal v-model="remarkVisible" :title="$t('page_bom_remark')" @ok="createRemark">
      <div style="padding:32px;width:100%;height:100%;box-sizing:border-box">
        <div style="display:flex;align-items:center;margin-bottom:32px">
          <span style="width:80px;text-align:right;margin-right:8px;">{{$t("page_bom_bom_no")}}:</span>
          <span>{{v.version}}</span>
        </div>
        <div style="display:flex;align-items:center;">
          <span style="width:80px;text-align:right;margin-right:8px;">{{$t("page_bom_remark_content")}}:</span>
          <a-textarea :disabled="v.versionStatus == 1" :maxLength="200" v-model="remark"></a-textarea>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { BomVersionServiceProxy, BomMaterialServiceProxy, MaterialServiceProxy } from "@/service-proxies/app-v2/material.service-proxies"
import { ProductionCraftServiceProxy } from "@/service-proxies/app-v2/product.service-proxies"
import { unFlatTreeData } from "@/components/RenderUtils/utils"
import Ellipsis from '@/components/Ellipsis/index'

const bvsp = new BomVersionServiceProxy()
const bmsp = new BomMaterialServiceProxy()
const msp = new MaterialServiceProxy()
const pcsp = new ProductionCraftServiceProxy()

export default {
  components: {
    Ellipsis
  },
  props: {
    productId: String,
    productCode: String
  },
  data() {
    return {
      selects: [],
      tree: [],
      remarkVisible: false,
      remark: "",
      craftVisible: false,
      crafts: [],
      selectCraft: null,
      versions: [],
      selectVersion: null,
      form: null,
      materials: [],
      processes: [],
      isCreate: false,
      selectTreeId: null,
      parentLevel: null,
      isLoading: false,
    }
  },
  computed: {
    v() {
      return this.versions.find(item => item.id === this.selectVersion) || {}
    }
  },
  watch: {
    productId: {
      handler: function(val) {
        if(!val) return
        this.resetData()
      },
      immediate: true
    },
    selectVersion(val) {
      this.tree = []
      this.processes = []
      this.form = null
      this.selects = []
      this.selectTreeId = null
      this.parentLevel = null
      if(val === null) {
        return
      }
      this.getTree()
      this.getPorcesses()
    }
  },
  async mounted() {
    const data = await msp.getMaterialList(2)
    this.materials = data
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    async getPorcesses() {
      const craftId = this.v.craftId
      const processes = await pcsp.getProcessForProductionCraft(craftId) || []
      this.processes = processes
    },
    resetData() {
      this.getVersions(0)
      this.getCrafts()
      this.processes = []
      this.tree = []
      this.form = null
    },
    changeMaterial(val) {
      const find = this.materials.find(item => item.code === val)
      this.form.materialCode = find.code
      this.form.materialId = find.id
      this.form.materialName = find.name
      this.form.materialType = find.typeName
      this.form.property = find.property
      this.form.standardModel = find.standardModel
      this.form.stuff = find.stuff
      this.form.unit = find.unit
      this.form.lowerLimit = find.lowerLimit
      this.form.upperLimit = find.upperLimit
      // this.form.level = find.level
      // this.form.parentLevel = find.parentLevel
    },
    addProcess() {
      this.form.processAddDTOS.push({
        bomMaterialId: this.selectTreeId,
      })
    },
    changeProcess(id, item) {
      const p = this.processes.find(item => item.id === id)
      item.processCode = p.code
      item.processName = p.name
    },
    async getTree() {
      const treedata = await bmsp.materialList(this.productCode, this.selectVersion)
      const tree = unFlatTreeData("id", "parentId" , null)(treedata, (item) => ({
        key: item.id,
        title: `${item.materialName}(${item.materialCode})`
      }))
      this.tree = tree
    },
    async selectTree([id] = [], e ,bool) {
      if(!bool) {
        this.selectTreeId = id
        this.parentLevel = e.node.dataRef.level
      }else {
        id = this.selectTreeId
      }
      // console.log(id)


      if(!id || id == 0) {
        this.form = null
        return
      }

      const data = await bmsp.materialDetail(id)
      const processAddDTOS = data.processVOList
      delete data.processVOList

      this.form = {
        ...data,
        processAddDTOS
      }
      this.isCreate = false
    },
    relateMaterial() {
      this.form = {
        parentId: this.selectTreeId,
        parentLevel: this.parentLevel,
        processAddDTOS: [],
        versionId: this.v.id
      }
      this.isCreate = true
    },
    async saveMaterial() {
      this.isLoading = true
      console.log(111, this.form)
      if (!this.checkProcess(this.form.processAddDTOS)) {
        this.$message.error('请选择关联工序！')
        this.isLoading=false
        return
      }
        setTimeout(() => {
          this.isLoading = false
        },500)

        await bmsp.createBomMaterial(this.form)
        this.$message.success(this.$t("save_success"))



      // if(!this.isCreate) return

      this.form = null
      await this.getTree()
      this.$nextTick(() => {
        this.selectTree(undefined, undefined, true)
      })
    },
    async cancelMaterial() {
      if(this.isCreate) {
        this.form = null
        this.$nextTick(() => {
          this.selectTree(undefined, undefined, true)
        })
        return
      }

      await bmsp.deleteBomMaterial(this.selectTreeId)
      this.form = null
      this.selects = []
      this.selectTreeId = null
      this.parentLevel = null
      this.$message.success(this.$t("delete_success"))
      this.$nextTick(() => this.getTree())
    },
    async getCrafts() {
      const crafts = await pcsp.getProductCraftRemark(this.productId) || []
      this.crafts = crafts
    },
    async getVersions(index) {
      const versions = await bvsp.getBomVersionByProduct(this.productId) || []
      this.versions = versions
      if(index !== undefined) {
        if(versions.length <= 0) {
          this.selectVersion = null
          return
        }
        if(index < 0) index = versions.length + index
        this.selectVersion = versions[index].id
      }
    },
    async createVersion() {
      if(!this.selectCraft) {
        this.$message.error(this.$t("page_bom_choose_version"))
        return
      }
      const craft = this.crafts.find(item => item.id === this.selectCraft)
      await bvsp.createBomMaterial({
        craftId: craft.id,
        craftVersion: craft.version,
        productId: this.productId
      })
      this.getVersions(-1)
      this.craftVisible = false
      this.$message.success(this.$t("create_success"))
    },
    async deleteVersion() {
      await bvsp.deleteBomVersion(this.selectVersion)
      this.$message.success(this.$t("delete_success"))
      this.getVersions(0)
    },
    async fixVersion() {
      await bvsp.fixedEditionForBom(this.selectVersion)
      this.v.versionStatus = 1
      this.$message.success(this.$t("page_bom_fix_success"))
    },
    async createRemark() {
      await bvsp.saveBomRemark({
        remark: this.remark,
        versionId: this.selectVersion
      })
      this.remarkVisible = false
      this.v.remark = this.remark
      this.$message.success(this.$t("page_bom_remark_succrss"))
    },
    checkProcess(processAddDTOS) {
      let flag = true
      if (!processAddDTOS|| processAddDTOS.length === 0) {
        return false
      }
      processAddDTOS.forEach(res => {
        if (!res.processCode) {
          flag = false
        }
      })
      return flag
    }
  }
}
</script>

<style lang="less" scoprd>
.bom-table {
  td,th {
    height: 32px;
    line-height: 30px;
    border:1px solid #eee;
    text-align: center;
    word-break: keep-all;
  }
  td {
    padding: 8px 24px;
  }
  th {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
